import React from "react";
import { Check, ArrowRight } from "lucide-react";
import { JOTFORM_URL } from "../constants";
import { useSite } from "../contexts/SiteContext";
import { useCurrency } from "../contexts/CurrencyContext";
import { formatPrice, replaceCurrency } from "../lib/currency";

const Feature = ({ label, value, dark }) => (
  <div className="plan-feature">
    <span style={{ color: dark ? "rgba(255,255,255,0.7)" : "#5F5A72", fontSize: 13 }}>{label}</span>
    <span style={{ fontWeight: 700, fontSize: 14, textAlign: "right" }}>{value}</span>
  </div>
);

const Plans = () => {
  const { content } = useSite();
  const { currency } = useCurrency();
  const plans = content.plans || {};
  const regular = plans.regular || {};
  const intensive = plans.intensive || {};
  return (
    <section id="planes" style={{ padding: "90px 24px" }}>
      <div style={{ maxWidth: 1240, margin: "0 auto" }}>
        <div className="fade-in" style={{ maxWidth: 780, marginBottom: 48 }}>
          <span className="pill" style={{ marginBottom: 16 }}>
            <span style={{ width: 18, height: 1, background: "#1A1352" }} /> {plans.kicker}
          </span>
          <h2 className="h-display" style={{ fontSize: "clamp(32px, 4.4vw, 56px)", margin: "12px 0 16px" }}>
            {plans.titleLine1}<br />
            {plans.titleLine2Prefix}<span className="text-grad-purple">{plans.titleLine2Highlight}</span>{plans.titleLine2Suffix}
          </h2>
          <p style={{ color: "#5F5A72", fontSize: 16, lineHeight: 1.55 }}>{replaceCurrency(plans.subtitle, currency)}</p>
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 26 }} className="plans-grid">
          <article className="plan-card fade-in">
            <span className="pill" style={{ marginBottom: 18 }}>{regular.badge}</span>
            <h3 className="h-display" style={{ fontSize: 34, margin: "0 0 10px" }}>{regular.name}</h3>
            <p style={{ color: "#5F5A72", fontSize: 14.5, lineHeight: 1.55, marginBottom: 18 }}>{regular.description}</p>
            <div style={{ display: "flex", alignItems: "baseline", gap: 6, marginBottom: 22 }}>
              <span className="h-display" style={{ fontSize: 56 }}>{formatPrice(regular.price, currency)}</span>
              <span style={{ color: "#5F5A72", fontSize: 15 }}>{regular.priceSuffix}</span>
            </div>
            <div>
              {(regular.features || []).map((f, i) => (
                <Feature key={i} label={f.label} value={f.value} />
              ))}
            </div>
            <a href={JOTFORM_URL} target="_blank" rel="noopener noreferrer" className="btn-dark" style={{ width: "100%", justifyContent: "center", marginTop: 26 }}>
              {regular.ctaText} <ArrowRight size={16} />
            </a>
          </article>

          <article className="plan-card plan-featured fade-in" style={{ position: "relative" }}>
            <span className="pill-orange-solid" style={{ position: "absolute", top: 24, right: 24 }}>
              <Check size={11} style={{ marginRight: 4, display: "inline" }} /> {intensive.badgeRibbon}
            </span>
            <span className="pill pill-dark" style={{ marginBottom: 18, background: "rgba(255,255,255,0.12)" }}>{intensive.badge}</span>
            <h3 className="h-display" style={{ fontSize: 34, color: "#fff", margin: "0 0 10px" }}>{intensive.name}</h3>
            <p style={{ color: "rgba(255,255,255,0.8)", fontSize: 14.5, lineHeight: 1.55, marginBottom: 18 }}>{intensive.description}</p>
            <div style={{ display: "flex", alignItems: "baseline", gap: 6, marginBottom: 22 }}>
              <span className="h-display plan-price" style={{ fontSize: 56, color: "#fff" }}>{formatPrice(intensive.price, currency)}</span>
              <span style={{ color: "rgba(255,255,255,0.8)", fontSize: 15 }}>{intensive.priceSuffix}</span>
            </div>
            <div>
              {(intensive.features || []).map((f, i) => (
                <Feature key={i} label={f.label} value={f.value} dark />
              ))}
            </div>
            <a href={JOTFORM_URL} target="_blank" rel="noopener noreferrer" className="btn-orange" style={{ width: "100%", justifyContent: "center", marginTop: 26 }}>
              {intensive.ctaText} <ArrowRight size={16} />
            </a>
          </article>
        </div>
      </div>
      <style>{`@media (max-width: 900px){.plans-grid{grid-template-columns:1fr !important;}}`}</style>
    </section>
  );
};

export default Plans;
